import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.976 8.042c1.573.88 1.52 3.215-.157 3.998L4.985 17.556c-1.871.872-3.831-1.025-3.02-2.924l1.856-4.337.026-.072a.75.75 0 0 0 0-.446l-.026-.072-1.856-4.337c-.812-1.899 1.148-3.796 3.02-2.924l11.834 5.517zm-.791 2.637a.75.75 0 0 0 .101-1.302l-.101-.057L4.35 3.803c-.624-.29-1.277.342-1.007.975L5.2 9.115l.05.132h3.867a.75.75 0 0 1 0 1.5H5.252l-.051.138-1.856 4.337c-.27.633.383 1.265 1.007.975z"
    }, null, -1)
  ]))]))
}
export default { render: render }